import type {
  IHubCatalog,
  IHubPackage,
  IHubPackageCatalogRelation,
} from "@models";
import { plainCatalogDescription } from "./plainCatalogDescription";

/** Build virtual checkout rows from cart package relations (same shape as CheckoutPage). */
export function catalogRelationToCheckoutRow(
  parent: IHubPackage,
  rel: IHubPackageCatalogRelation,
  catalog: IHubCatalog | undefined,
): IHubPackage {
  const base: IHubPackage = {
    packageId: parent.packageId,
    name: "",
    label: "",
    description: "",
    status: parent.status,
    catalogRelations: [rel],
    visibility: parent.visibility,
  };
  if (!catalog) return base;
  return {
    ...base,
    name: catalog.name ?? "",
    label: catalog.label ?? catalog.name ?? "",
    description: plainCatalogDescription(catalog.description ?? ""),
  };
}

export function buildCheckoutRowsFromCart(
  cartPackage: IHubPackage | undefined,
  catalogs: IHubCatalog[],
): IHubPackage[] {
  const rels = cartPackage?.catalogRelations;
  if (!cartPackage || !rels?.length) return [];
  return rels.map((rel) => {
    const catalog = catalogs.find(
      (c) =>
        (c.catalogId ?? 0) === rel.catalogId &&
        (c.version ?? 0) === rel.catalogVersion,
    );
    return catalogRelationToCheckoutRow(cartPackage, rel, catalog);
  });
}
